export default __webpack_public_path__ + "static/media/kerberos.e0646ca0.png";